import * as React from 'react'

import { ExperimentsContext } from '../../context'
import { Experiment as ExperimentType } from '../../types'
import ExperimentActivator from '../ExperimentActivator'

export interface Props {
  children: React.ReactNode
  experiment: ExperimentType
}

class Experiment extends React.Component<Props> {
  render() {
    const { children, experiment } = this.props
    return (
      <ExperimentActivator experiment={experiment}>
        {(_, selectedVariantId) => (
          <ExperimentsContext.Provider value={{ experiment, selectedVariantId }}>
            {children}
          </ExperimentsContext.Provider>
        )}
      </ExperimentActivator>
    )
  }
}

export default Experiment
